<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-button @click.prevent="onShowCreatePopup()" class="bg_l_green">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateGrouping") }}
          </vs-button>
        </div>
        <div class="vx-row" v-if="loaded">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('GroupName') },
                { title: $t('Zone') },
                { title: $t('PhoneNumberLeader') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.name }}
                </td>
                <td style="width: 10%">
                  {{ row.zone }}
                </td>
                <td style="width: 20%">
                  {{ row.leaderName }}
                </td>
                <td style="width: 50%">
                  <div
                    class="w-full h-full flex gap-4 justify-center items-center"
                  >
                    <vs-button
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      @click.prevent="isStartCountingForThisGroup(row.id)"
                      :disabled="row.isCompleted"
                      >{{ $t("StartCounting") }}</vs-button
                    >
                    <vs-button
                      color="warning"
                      type="gradient"
                      icon-pack="feather"
                      @click.prevent="isEndCountingForThisGroup(row.id)"
                      :disabled="row.isCompleted"
                      >{{ $t("EndCounting") }}</vs-button
                    >
                    <vs-button
                      color="primary"
                      type="gradient"
                      icon-pack="feather"
                      @click.prevent="onShowSubmitBarcode(row.id)"
                      >{{ $t("ShowSubmitBarcode") }}</vs-button
                    >
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <start-counting-popup
          :countingGroupId="countGroupId"
          :countingTagId="countTagId"
          :show="isStartCountingPopup"
          @finish="onfinish"
          @close="closeStartCountingPopup"
        ></start-counting-popup>
        <show-submit-barcode-popup
          :countGroupId="countGroupId"
          :countTagId="countTagId"
          :show="isShowSubmitBarcodePopup"
          @close="closeShowSubmitBarcodePopup"
        ></show-submit-barcode-popup>
        <create-popup
          :stockTakingId="stockTakingId"
          :show="isStartAndModifyPopup"
          @close="closeCreatePopup"
          @finish="onfinish"
        ></create-popup>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "../Grouping/CreatePopup.vue";
import ShowSubmitBarcodePopup from "./ShowSubmitBarcodePopup.vue";
import StartCountingPopup from "./StartCountingPopup.vue";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_WarehouseHandling_Index",
  components: {
    DataGrid,
    CreatePopup,
    StartCountingPopup,
    ShowSubmitBarcodePopup,
  },
  data() {
    return {
      countTagId: "",
      countGroupId: "",
      manualUrlService: "",
      stockTakingId: "",
      loaded: false,
      isDiscrepancyPopup: false,
      isShowSubmitBarcodePopup: false,
      isStartCountingPopup: false,
      isStartAndModifyPopup: false,
      gridDataSource: { data: [] },
      gridSearchData: {},
      modelForDelete: {},
      modelForFinish: {},
      modelForDiscrepanct: {},
    };
  },
  mounted() {
    this.countTagId = this.$route.params.id;
    this.manualUrlService =
      "Inventory/api/CountingTagQuery/" + this.countTagId + "/groups";
    this.gridDataSource = { type: "app", service: this.manualUrlService };
    setTimeout(() => {
      this.loaded = true;
    }, 100);
  },
  methods: {
    ...mapActions({
      removeCountingTag: "warehouseHandling/removeCountingTag",
      completeCountingGroup: "warehouseHandling/completeCountingGroup",
    }),
    closeShowSubmitBarcodePopup() {
      this.isShowSubmitBarcodePopup = false;
    },
    closeStartCountingPopup() {
      this.isStartCountingPopup = false;
    },
    closeCreatePopup() {
      this.isStartAndModifyPopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      this.isDiscrepancyPopup = false;
      this.closeShowSubmitBarcodePopup();
      this.closeStartCountingPopup();
      this.$refs.grid.renderGrid(1, true);
    },
    onShowCreatePopup() {
      this.isStartAndModifyPopup = true;
    },
    onShowDiscrepancyPopup(id) {
      this.countTagId = id;
      this.isDiscrepancyPopup = true;
    },
    isStartCountingForThisGroup(countGroupId) {
      this.countGroupId = countGroupId;
      this.isStartCountingPopup = true;
    },
    onShowSubmitBarcode(countGroupId) {
      this.countGroupId = countGroupId;
      this.isShowSubmitBarcodePopup = true;
    },
    isEndCountingForThisGroup(id) {
      this.$swal({
        title: "آیا از اتمام شمارش برای گروه " + id + " اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.modelForFinish.countingGroupId = id;
          this.modelForFinish.countingTagId = parseInt(this.countTagId);
          this.completeCountingGroup(this.modelForFinish).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    deleteCountingTag(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.modelForDelete.id = id;
          this.removeCountingTag(this.modelForDelete).then();
        }
      });
    },
  },
};
</script>
